import { Backdrop, Card, CardContent, CardHeader, CircularProgress, Checkbox, Chip, Container, Divider, Grid, Snackbar, Table, TableCell, TableContainer, TableBody, TableHead, TableRow, TextField, createTheme, Button, TablePagination, TableSortLabel, Autocomplete, Stack } from '@mui/material';
import Alert from 'src/components/Alert';
import React, { useState, useEffect } from 'react';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import { useTheme } from '@mui/material/styles';

import trLocale from 'date-fns/locale/tr';

import axios from 'src/utils/axios';
import SearchIcon from '@mui/icons-material/Search';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PrintIcon from '@mui/icons-material/Print';
import ExcelFileCreator from 'src/components/ExcelFileCreator';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';


const materialTheme = createTheme({
    palette: {
        primary: {
            contrastText: '#FF9800',
            dark: '#424242',
            main: '#424242',
            light: '#424242'
        }
    }
});

const localeMap = {
    tr: trLocale
};

function parseDateTime(dateTimeString) {
    const [dateString, timeString] = dateTimeString.split(' ');
    const [day, month, year] = dateString.split('.');
    const [hours, minutes] = timeString.split(':');
    return new Date(year, month - 1, day, hours, minutes);
}

function descendingComparator(a, b, orderBy) {
    if (orderBy === 'Tarih') {
        const dateA = parseDateTime(a[orderBy]);
        const dateB = parseDateTime(b[orderBy]);

        if (dateB < dateA) {
            return -1;
        }
        if (dateB > dateA) {
            return 1;
        }
        return 0;
    }
    else {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    rootlist: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 550
    }),
    rootlistsag: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 500
    }),

    cardBolum: {
        maxHeight: 700,
        minHeight: 700,
        width: '100%'
    },
    table: {
        minWidth: 650
    },
    content: {
        minHeight: 550
    },
    chatSection: {
        width: '100%'
    },
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        overflowY: 'auto'
    },
    button: (theme) => ({
        margin: theme.spacing(1)
    }),
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }),
    actionsCCFile: {
        justifyContent: 'flex-end'
    },
    responsiveContainer: (theme) => ({
        marginTop: theme.spacing(3),
        [theme.breakpoints.between('md', 'lg')]: {
            maxHeight: '70vh',
            overflowX: 'hidden',
            overflowY: 'scroll'
        },
        [theme.breakpoints.down('sm')]: {
            maxHeight: '60vh',
            overflow: 'scroll'
        }
    }),
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '10px',
        borderRadius: 10,
    },
    switch_track: {
        backgroundColor: "#263238",
    },
    switch_base: {
        color: '#FF9800',
        "&.Mui-disabled": {
            color: '#FF9800'
        },
        "&.Mui-checked": {
            color: "#FF9800"
        },
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#263238",
        }
    },
    switch_primary: {
        "&.Mui-checked": {
            color: "#263238",
        },
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#263238",
        },
    },
};

function EmployeeIdentifyReport() {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const SessionUser = getUser();

    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };
    const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
    const [BirimData, setBirimData] = React.useState([]);
    const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
    const [SelectedBirim, setSelectedBirim] = React.useState([]);

    const [employeeReportData, setEmployeeReportData] = React.useState([]);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(10);

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;
    const selectAllIcon = <PlaylistAddCheckIcon fontSize="small" />;


    const SelectAllOption = { BirimKodu: 0, Dsc: 'Tümü' };
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('ElemanNo');
    const sortedRows = stableSort(employeeReportData, getComparator(order, orderBy));

    useEffect(() => {
        setLoading(true);
        getBolgeAdiKoduData();
        setLoading(false);
    }, []);

    const getBolgeAdiKoduData = () => {
        axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
            setBolgeAdiKodu(response?.data);
        })

    }

    const getBirimData = (BirimKodu) => {

        if (!BirimKodu || BirimKodu.length < 1) {
            setBirimData([]);
        } else {
            setLoading(true);
            axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu.join("&BirimKodu=")}`).then((response) => {
                setBirimData([SelectAllOption, ...response.data]);
                setLoading(false);
            });
        }
    }


    const getReport = () => {
        setLoading(true);
        setEmployeeReportData([]);
        const birimKoduQuery = !SelectedBirim || SelectedBirim.length < 1 || SelectedBirim.find((x) => x.BirimKodu == 0) ? '0'
            : SelectedBirim?.map(x => x.BirimKodu).join("&BirimKodu=");
        const bolgeKoduQuery = !selectedbolgeAdiKodu || selectedbolgeAdiKodu.length < 1 || selectedbolgeAdiKodu.find((x) => x.BirimKodu == 0) ? '0'
            : selectedbolgeAdiKodu?.map(x => x.BirimKodu).join("&BolgeKodu=");
        axios.get(`GetApolloEmployeeTypeReport?BolgeKodu=${bolgeKoduQuery}&BirimKodu=${birimKoduQuery}`).then((response) => {
            if (response.data.length > 0) {
                var reportDataTMP = response.data;
                setEmployeeReportData(reportDataTMP);
                setLoading(false);
            } else {
                setresponseMessage('Hiç data bulunamadı!...');
                setUyariTip('error');
                setUyari(true);
                setLoading(false);
            }
        }).catch(error => {
            setLoading(false);
        });

    }

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const clearAllInputs = () => {
        setSelectedbolgeAdiKodu([]);
        setSelectedBirim([]);
        setEmployeeReportData([]);
        setpg(0);
        setrpg(10);
    }

    const handleExportClick = () => {
        var exportData = [];
        sortedRows.map((item) => {
            exportData.push({
                'ServisKodu-Açıklaması': item.Servis,
                'Eleman No': item.ElemanNo,
                'Log Tipi': item.LOG_TIPI,
                'İsim': item.Ad,
                'Soyisim': item.Soyad,
                'EskiDeger': item.ESKI_DEGER,
                'YeniDeger': item.YeniDeger,
                'Tarih': item.Tarih,
                'Kaydeden': item.Kaydeden,
            })
        })
        ExcelFileCreator(exportData, `Çalışan Kimlik Tarihçe`);
    };

    const renderOption = (props, option, { selected }) => (
        <li {...props}>
            <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
            />
            {option.Dsc}
        </li>
    );




    return (
        <Page sx={styles.root}>
            <Backdrop sx={styles.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
                ></Alert>
            </Snackbar>
            <Container style={styles.container1} maxWidth="xl">
                <Card>
                    <CardHeader title="Çalışan Kimlik Tarihçe" />
                    <Divider />
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid size={6}>
                            </Grid>
                            <Grid size={6}>
                                <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                                    <Button
                                        sx={styles.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            getReport();
                                        }}
                                    >
                                        ARA
                                        <SearchIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                    <Button
                                        sx={styles.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            handleExportClick();
                                        }}
                                        style={{ marginRight: '5px' }} // Add margin to the right
                                    >
                                        YAZDIR
                                        <PrintIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                </Stack>
                            </Grid>

                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 6
                                }}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    id="combo-box-demo"
                                    fullWidth
                                    value={selectedbolgeAdiKodu}
                                    options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                                    getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                                    renderOption={renderOption}
                                    onChange={(event, newValue) => {
                                        setSelectedbolgeAdiKodu(newValue);
                                        var bolgeKodu = newValue?.find(x => x.BirimKodu == 0) ? bolgeAdiKodu.map(x => x.BirimKodu) : newValue.map(x => x.BirimKodu);
                                        getBirimData(bolgeKodu);
                                        setSelectedBirim([])
                                    }}
                                    renderTags={(tagValue, getTagProps) => {
                                        if (bolgeAdiKodu.length > 0 && tagValue.length === bolgeAdiKodu.length) {
                                            return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                                        }
                                        const visibleCount = 1;
                                        return (
                                            <>
                                                {tagValue.slice(0, visibleCount).map((option, index) => (
                                                    <Chip size="small" key={option.BirimKodu} label={option.Dsc} {...getTagProps({ index })} />
                                                ))}
                                                {tagValue.length > visibleCount && (
                                                    <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                                                )}
                                            </>
                                        );
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 6
                                }}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    id="combo-box-demo"
                                    fullWidth
                                    value={SelectedBirim}
                                    options={BirimData.length > 0 ? BirimData : []}
                                    getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                                    renderOption={renderOption}
                                    onChange={(event, newValue) => {
                                        newValue?.find(x => x.Id == -1) ? setSelectedBirim(BirimData) : setSelectedBirim(newValue);
                                    }}
                                    renderTags={(tagValue, getTagProps) => {
                                        if (BirimData.length > 0 && tagValue.length === BirimData.length) {
                                            return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                                        }
                                        const visibleCount = 1;
                                        return (
                                            <>
                                                {tagValue.slice(0, visibleCount).map((option, index) => (
                                                    <Chip size="small" key={option.BirimKodu} label={option.Dsc} {...getTagProps({ index })} />
                                                ))}
                                                {tagValue.length > visibleCount && (
                                                    <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                                                )}
                                            </>
                                        );
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 12
                                }}>
                                <TableContainer >
                                    <Table stickyHeader aria-label="sticky table" size="small">
                                        <TableHead style={{ overflowWrap: 'break-word' }}>
                                            <TableRow>
                                                <TableCell
                                                    align="left"
                                                    sortDirection={orderBy === 'Servis' ? order : false}>
                                                    <TableSortLabel
                                                        active={orderBy === 'Servis'}
                                                        direction={orderBy === 'Servis' ? order : 'asc'}
                                                        onClick={() => { handleRequestSort('Servis') }}>
                                                        Servis Kodu-Açıklaması
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    sortDirection={orderBy === 'ElemanNo' ? order : false}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === 'ElemanNo'}
                                                        direction={orderBy === 'ElemanNo' ? order : 'asc'}
                                                        onClick={() => { handleRequestSort('ElemanNo') }}
                                                    >
                                                        Eleman No
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    sortDirection={orderBy === 'LOG_TIPI' ? order : false}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === 'LOG_TIPI'}
                                                        direction={orderBy === 'LOG_TIPI' ? order : 'asc'}
                                                        onClick={() => { handleRequestSort('LOG_TIPI') }}
                                                    >
                                                        Log Tipi
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    sortDirection={orderBy === 'Ad' ? order : false}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === 'Ad'}
                                                        direction={orderBy === 'Ad' ? order : 'asc'}
                                                        onClick={() => { handleRequestSort('Ad') }}
                                                    >
                                                        İsim
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    sortDirection={orderBy === 'Soyad' ? order : false}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === 'Soyad'}
                                                        direction={orderBy === 'Soyad' ? order : 'asc'}
                                                        onClick={() => { handleRequestSort('Soyad') }}
                                                    >
                                                        Soyisim
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    sortDirection={orderBy === 'ESKI_DEGER' ? order : false}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === 'ESKI_DEGER'}
                                                        direction={orderBy === 'ESKI_DEGER' ? order : 'asc'}
                                                        onClick={() => { handleRequestSort('ESKI_DEGER') }}
                                                    >
                                                        Eski Değer
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    sortDirection={orderBy === 'YeniDeger' ? order : false}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === 'YeniDeger'}
                                                        direction={orderBy === 'YeniDeger' ? order : 'asc'}
                                                        onClick={() => { handleRequestSort('YeniDeger') }}
                                                    >
                                                        Yeni Değer
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    sortDirection={orderBy === 'Tarih' ? order : false}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === 'Tarih'}
                                                        direction={orderBy === 'Tarih' ? order : 'asc'}
                                                        onClick={() => { handleRequestSort('Tarih') }}
                                                    >
                                                        Tarih
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    sortDirection={orderBy === 'Kaydeden' ? order : false}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === 'Kaydeden'}
                                                        direction={orderBy === 'Kaydeden' ? order : 'asc'}
                                                        onClick={() => { handleRequestSort('Kaydeden') }}
                                                    >
                                                        Kaydeden
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell align="left" />
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedRows.length > 0 && sortedRows.slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                                                <TableRow
                                                    key={row.Id}
                                                >
                                                    <TableCell align="left">{row.Servis || "-"}</TableCell>
                                                    <TableCell align="left">{row.ElemanNo || "-"}</TableCell>
                                                    <TableCell align="left">{row.LOG_TIPI || "-"}</TableCell>
                                                    <TableCell align="left">{row.Ad || "-"}</TableCell>
                                                    <TableCell align="left">{row.Soyad || "-"}</TableCell>
                                                    <TableCell align="left">{row.ESKI_DEGER || "-"}</TableCell>
                                                    <TableCell align="left">{row.YeniDeger || "-"}</TableCell>
                                                    <TableCell align="left">{row.Tarih || "-"}</TableCell>
                                                    <TableCell align="left">{row.Kaydeden || "-"}</TableCell>
                                                    <TableCell align="left" />
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {sortedRows.length > 0 &&
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={sortedRows.length}
                                        rowsPerPage={rpg}
                                        page={pg}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                }
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </Page >
    );
}
export default EmployeeIdentifyReport;
